import { ReferralStage, ReferralChannel } from "@/pages/Attendance/ReferralPopup/types"

export const REFERRAL_REWARD_AMOUNT = 200
export const REFERRAL_DEADLINE = "2026-09-30T23:59:00"
export const REFERRAL_VALIDITY_DAYS = 90
export const REFERRAL_PARTNER_WALLET_URL = "https://parceiros.letalk.com.br/carteira"

export const REFERRAL_COPY_FEEDBACK_DURATION_IN_MS = 1800

export const REFERRAL_SWAP_OUT_DURATION_IN_MS = 200
export const REFERRAL_SWAP_IN_DURATION_IN_MS = 340
export const REFERRAL_SWAP_GAP_IN_MS = 20

export const REFERRAL_WHATSAPP_MESSAGE = "Olá! Estou indicando a Letalk para você. Acesse meu link de indicação:"

export const stageToWidthInPixels: Record<ReferralStage, number> = {
	offer: 520,
	form: 640,
	link: 600,
	done: 640
}

export const channelToLabel: Record<ReferralChannel, string> = {
	google_ads: "Google Ads",
	meta_ads: "Meta Ads"
}
